export default '/build/5a7fab7c.svg'